const weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

// 将秒转化为年月日时分秒
const getDuration = (second) => {
  const days = Math.floor(second / 86400);
  const hours = Math.floor((second % 86400) / 3600);
  const minutes = Math.floor(((second % 86400) % 3600) / 60);
  const seconds = Math.floor(((second % 86400) % 3600) % 60);

  return {
    day: days,
    hours,
    minutes,
    seconds,
  };
};

// 获取当前时间
const getTime = () => {
  const curTime = new Date();
  const curHour = curTime.getHours();
  const curMinute = curTime.getMinutes();

  return {
    curHour,
    curMinute,
  };
};

// 判断是否时间戳
const isTimestramp = (timestarmp) => {
  if (!timestarmp) {
    return false;
  }
  if (timestarmp.toString().length === 13 && isNaN(timestarmp) === false) {
    return true;
  }
  return false;
};

// 判断是否时间格式
const isTime = (date) => {
  const t = new Date(date);
  return t !== 'Invalid Date';
};

// 时间兼容处理
const isDate = (date) => {

  if (!date) {
    return false;
  }

  if (typeof date === 'string') {
    return date.replace(/-/g, '/');
  }

  return !!Date.parse(date);
};


// 获取时间戳
const getTimeStramp = (date) => {
  if (isDate(date)) {
    return new Date(beautifulDate(date)).getTime();
  }

  return '';
};

// 兼容处理时间对象
const beautifulDate = (date) => {
  if (!date) {
    return '';
  }

  if (typeof date === 'string') {
    return date.replace(/-/g, '/');
  }

  return date;
};

// 传入数字 返回指定周
const getWeek = (number) => {
  const week = weekList[number];
  if (!week) {
    return '';
  }
  return week;
};

export default {
  getDuration,
  getTime,
  isTimestramp,
  isTime,
  isDate,
  getTimeStramp,
  beautifulDate,
  getWeek,
};
